import React from 'react';
import Picture from "./Picture";
import DragDrop from "./DragDrop";
import {Col, Row} from "reactstrap";
import Spinner from "./Spinner";
import './App.css';
import ReservationDetailsModal from "./ReservationDetailsModal";
import Cookies from "js-cookie";
import axios_event from "../../../../../axios/axios_eventtag";
import apiConfig from "../../../../../axios/axios_api_services";
import * as common from "../../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import * as innerRoutes from "../InnerRoutes/InnerRoutes";
import {withRouter} from "react-router-dom";
import {notifyMessage} from "../../../../../const/Common/CommonFunc";

const PictureList = [
    // {
    //     id: 1,
    //     url: "https://semantic-ui.com/images/avatar2/large/elyse.png"
    // },
    // {
    //     id: 2,
    //     url: "https://semantic-ui.com/images/avatar2/large/matthew.png"
    // },
    // {
    //     id: 3,
    //     url: "https://semantic-ui.com/images/avatar2/large/kristy.png"
    // }

    {
        id: 1,
        url: "Person 1"
    },
    {
        id: 2,
        url: "Person 2"
    },
    {
        id: 3,
        url: "Person 3"
    }
];

class DropContainer extends React.Component {

    state = {
        loading: false,
        isOpen: false,
        // PictureList: [
        //     {
        //         id: 1,
        //         url: "Person 1"
        //     },
        //     {
        //         id: 2,
        //         url: "Person 2"
        //     },
        //     {
        //         id: 3,
        //         url: "Person 3"
        //     },
        //     {
        //         id: 4,
        //         url: "Person 4"
        //     },
        //     {
        //         id: 5,
        //         url: "Person 5"
        //     },
        //     {
        //         id: 6,
        //         url: "Person 6"
        //     },
        //     {
        //         id: 7,
        //         url: "Person 7"
        //     },
        //     {
        //         id: 8,
        //         url: "Person 8"
        //     },
        //     {
        //         id: 9,
        //         url: "Person 9"
        //     },
        //     {
        //         id: 10,
        //         url: "Person 10"
        //     },
        //     {
        //         id: 11,
        //         url: "Person 11"
        //     },
        //     {
        //         id: 12,
        //         url: "Person 12"
        //     }
        // ],
        PictureList2: [
            {
                id: 1,
                url: "Person 1"
            },
            {
                id: 2,
                url: "Person 2"
            },
            {
                id: 3,
                url: "Person 3"
            },
            {
                id: 4,
                url: "Person 4"
            },
            {
                id: 5,
                url: "Person 5"
            },
            {
                id: 6,
                url: "Person 6"
            },
            {
                id: 7,
                url: "Person 7"
            },
            {
                id: 8,
                url: "Person 8"
            },
            {
                id: 9,
                url: "Person 9"
            },
            {
                id: 10,
                url: "Person 10"
            },
            {
                id: 11,
                url: "Person 11"
            },
            {
                id: 12,
                url: "Person 12"
            }
        ],



      PictureList: [
        // {
        //   userId:70076396,
        //   firstName:"Udara",
        //   lastName:"Mr Alistor",
        //   identificationType:null,
        //   identificationValue:"124563895624",
        //   mobile:"94758150669",
        //   email:"udaraalistor@gmail.com",
        //   department:null,
        //   budgetReferance:null,
        //   otherReferance:null,
        //   status:null,
        //   approvedUser:null,
        //   approvedDate:null,
        //   createdDate:"09-06-2021 08:06:57",
        //   addedUser:null,
        //   modifiedDate:"2021-10-15 05:41:23",
        //   modifyUser:null
        // },
        // {
        //   userId:70077209,
        //   firstName:"Lakshmi",
        //   lastName:"Kanchana",
        //   identificationType:null,
        //   identificationValue:null,
        //   mobile:"94702329664",
        //   email:"lklakshmikanchana@gmail.com",
        //   department:"",
        //   budgetReferance:null,
        //   otherReferance:null,
        //   status:null,
        //   approvedUser:null,
        //   approvedDate:null,
        //   createdDate:"06-10-2020 08:10:42",
        //   addedUser:null,
        //   modifiedDate:"2021-05-19 05:29:52",
        //   modifyUser:null
        // },
        // {
        //   userId:70077339,
        //   firstName:"Thilina",
        //   lastName:"Cooray",
        //   identificationType:"NIC",
        //   identificationValue:"942913230V",
        //   mobile:"94777338239",
        //   email:"8wy2ryvw2n@privaterelay.appleid.com",
        //   department:"Group Business Operations",
        //   budgetReferance:null,
        //   otherReferance:null,
        //   status:"Acive",
        //   approvedUser:null,
        //   approvedDate:null,
        //   createdDate:"22-10-2020 14:10:33",
        //   addedUser:null,
        //   modifiedDate:"2022-04-01 12:16:36",
        //   modifyUser:null
        // },
        // {
        //   userId:70077342,
        //   firstName:"Rashinda",
        //   lastName:"Silva",
        //   identificationType:"NIC",
        //   identificationValue:"N098765",
        //   mobile:"94773337030",
        //   email:"thilina.help@gmail.com",
        //   department:"Group Business Operations",
        //   budgetReferance:null,
        //   otherReferance:null,
        //   status:"Acive",
        //   approvedUser:null,
        //   approvedDate:null,
        //   createdDate:"22-10-2020 14:10:02",
        //   addedUser:null,
        //   modifiedDate:"2022-04-05 10:07:23",
        //   modifyUser:null
        // },
        // {
        //   userId:70077343,
        //   firstName:"Ramesh",
        //   lastName:"Indika",
        //   identificationType:"NIC",
        //   identificationValue:"198035403435",
        //   mobile:"94777336068",
        //   email:"ramesh.indika@dialog.lk",
        //   department:"Group Business Operations",
        //   budgetReferance:null,
        //   otherReferance:null,
        //   status:"Acive",
        //   approvedUser:null,
        //   approvedDate:null,
        //   createdDate:"22-10-2020 20:10:03",
        //   addedUser:null,
        //   modifiedDate:"2022-04-04 04:35:35",
        //   modifyUser:null
        // },
        // {
        //   userId:70081525,
        //   firstName:"Tharindu",
        //   lastName:"Athukorala",
        //   identificationType:null,
        //   identificationValue:null,
        //   mobile:"94778533935",
        //   email:"tharinduathukorala1@gmail.com",
        //   department:null,
        //   budgetReferance:null,
        //   otherReferance:null,
        //   status:null,
        //   approvedUser:null,
        //   approvedDate:null,
        //   createdDate:"15-10-2021 15:10:22",
        //   addedUser:null,
        //   modifiedDate:"2022-04-30 04:02:31",
        //   modifyUser:"10"
        // },
        // {
        //   userId:7008152512,
        //   firstName:"Tharindu",
        //   lastName:"Athukorala",
        //   identificationType:null,
        //   identificationValue:null,
        //   mobile:"94778533935",
        //   email:"tharinduathukorala1@gmail.com",
        //   department:null,
        //   budgetReferance:null,
        //   otherReferance:null,
        //   status:null,
        //   approvedUser:null,
        //   approvedDate:null,
        //   createdDate:"15-10-2021 15:10:22",
        //   addedUser:null,
        //   modifiedDate:"2022-04-30 04:02:31",
        //   modifyUser:"10"
        // },
        // {
        //   userId:700815234,
        //   firstName:"Tharindu",
        //   lastName:"Athukorala",
        //   identificationType:null,
        //   identificationValue:null,
        //   mobile:"94778533935",
        //   email:"tharinduathukorala1@gmail.com",
        //   department:null,
        //   budgetReferance:null,
        //   otherReferance:null,
        //   status:null,
        //   approvedUser:null,
        //   approvedDate:null,
        //   createdDate:"15-10-2021 15:10:22",
        //   addedUser:null,
        //   modifiedDate:"2022-04-30 04:02:31",
        //   modifyUser:"10"
        // },
        // {
        //   userId:700815388,
        //   firstName:"Tharindu",
        //   lastName:"Athukorala",
        //   identificationType:null,
        //   identificationValue:null,
        //   mobile:"94778533935",
        //   email:"tharinduathukorala1@gmail.com",
        //   department:null,
        //   budgetReferance:null,
        //   otherReferance:null,
        //   status:null,
        //   approvedUser:null,
        //   approvedDate:null,
        //   createdDate:"15-10-2021 15:10:22",
        //   addedUser:null,
        //   modifiedDate:"2022-04-30 04:02:31",
        //   modifyUser:"10"
        // },
        // {
        //   userId:700815225,
        //   firstName:"Tharindu",
        //   lastName:"Athukorala",
        //   identificationType:null,
        //   identificationValue:null,
        //   mobile:"94778533935",
        //   email:"tharinduathukorala1@gmail.com",
        //   department:null,
        //   budgetReferance:null,
        //   otherReferance:null,
        //   status:null,
        //   approvedUser:null,
        //   approvedDate:null,
        //   createdDate:"15-10-2021 15:10:22",
        //   addedUser:null,
        //   modifiedDate:"2022-04-30 04:02:31",
        //   modifyUser:"10"
        // },

      ],

      selected: null,
      seat: 0,

      reserved_seats: [
        // {
        //   seat: "R5-10",
        //   userDTO: {
        //     userId:700815225,
        //     firstName:"Tharindu",
        //     lastName:"Athukorala",
        //     identificationType:null,
        //     identificationValue:null,
        //     mobile:"94778533935",
        //     email:"tharinduathukorala1@gmail.com",
        //     department:null,
        //     budgetReferance:null,
        //     otherReferance:null,
        //     status:null,
        //     approvedUser:null,
        //     approvedDate:null,
        //     createdDate:"15-10-2021 15:10:22",
        //     addedUser:null,
        //     modifiedDate:"2022-04-30 04:02:31",
        //     modifyUser:"10"
        //   }
        // }
      ]

    };

    removeFromList = (id) => {
        let pictureList = this.state.PictureList;
        pictureList.map((picture, index) => {
           if(picture.id === id) {
               pictureList.splice(index, 1);
               this.setState({ PictureList: pictureList })
               this.setState({loading: true});
               window.setTimeout(this.load, 3000);
           }
        });
    };

    load = () => {
        this.setState({loading: false});
    };

  openReservationModal = (value, seat) => {
    this.setState({selected: value, seat: seat});
    this.openReservationModal_();
  };

  openReservationModal_ = () => {
    this.setState({isOpen: true});
  };

  closeReservationModal = () => {
    this.setState({isOpen: false, selected: null, seat: 0});
  };


  componentDidMount() {
    // console.log("==============================SUB-EVENT-ID: ", this.props.current_sub_event_id);
    // console.log("==============================SUB-EVENTS: ", this.props.current_sub_events);
    if (this.props.current_sub_event_id === undefined || this.props.current_sub_event_id === "" || this.props.current_sub_event_id === null) {
      if(this.props.usr_obj.userRoles ==="CORP_ADMIN") {
        this.props.history.push(innerRoutes.cor_inner_route_allEvents);
      } else {
        this.props.history.push(innerRoutes.inner_route_allEvents);
      }
      // this.props.pgChangeHandler(1);
      return;
    } else {
      if((this.props.current_sub_events!=null & this.props.current_sub_events!="" & this.props.current_sub_events!=undefined &this.props.current_sub_events.length!=0)) {
        this.props.setCurrentSubEvent(this.props.current_sub_event_idx);
        this.props.setCurrentSubEventsData(this.props.current_sub_events);
        this.loadParticipants();
      } else {
        if(this.props.usr_obj.userRoles ==="CORP_ADMIN") {
          this.props.history.push(innerRoutes.cor_inner_route_allEvents);
        } else {
          this.props.history.push(innerRoutes.inner_route_allEvents);
        }
      }
    }
  }


  loadParticipants = () => {

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    axios_event.get(apiConfig.LOAD_SEAT_RESERVATION_PARTICIPANTS({sub_event_id: this.props.current_sub_event_id, corporateId: corporateId})
      , {headers: headers})
      .then(response => {
        if (response.data.success) {
          this.setState({PictureList: response.data.content.participant, reserved_seats: response.data.content.reservation});
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.loadParticipants();
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  makeReservation = ( {id, seat} ) => {

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    axios_event.post(apiConfig.RESERVE_SEAT({sub_event_id: this.props.current_sub_event_id, corporateId: corporateId})
      , { seat: seat, user_id: id }, {headers: headers})
      .then(response => {
        if (response.data.success) {
          notifyMessage(`Reserved the seat ${seat} successfully!`, 2, 3);
          this.setState({PictureList: [], reserved_seats: []});
          this.updateReservationData(response.data.content.participant, response.data.content.reservation);
        } else {
          common.warningAlert(response.data.message, 1)
          this.loadParticipants();
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.makeReservation( id, seat );
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  removeFromTheSeat = ( seat_id ) => {

    this.props.spinnerHandler(true);

    let corporateId = this.props.usr_obj.corporates[0].corporateId;

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8"),
      "Content-Type": "application/json"
    };

    axios_event.delete(apiConfig.REMOVE_FROM_THE_SEAT({sub_event_id: this.props.current_sub_event_id, corporateId: corporateId, seat_id: seat_id}), {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("Participant removed from the seat successfully!", 0)
          this.setState({
            PictureList: [],
            reserved_seats: [],
            isOpen: false,
            selected: null,
            seat: 0
          });
          this.updateReservationData(response.data.content.participant, response.data.content.reservation);
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.removeFromTheSeat( seat_id );
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };


  updateReservationData = (participant, reservation) => {
    this.setState({PictureList: participant, reserved_seats: reservation});
  };

    render() {
        let { isOpen, PictureList, PictureList2, selected, seat } = this.state;
        let seat_count = 499;
        let grid_i = 1;
        let grid_array = [];
        let grid_all = [];

        let grid_fine = [];


          // [...Array(seat_count)].map((val,idx) => {
          //
          //   if(grid_i!=11) {
          //     let x = <div className={'md_new_col md_new_col-3'}>
          //       <DragDrop seat = { idx + 1 } pictureList = {PictureList} removeItem = { this.removeFromList } openReservationModal={this.openReservationModal}/>
          //     </div>;
          //     grid_array.push(x);
          //     grid_i = grid_i + 1;
          //     if(idx == (seat_count - 1)) {
          //       grid_all.push(grid_array);
          //     }
          //   } else {
          //     grid_all.push(grid_array);
          //     grid_array = [];
          //     grid_i = 2;
          //     let x = <div className={'md_new_col md_new_col-3'}>
          //       <DragDrop seat = { idx + 1 } pictureList = {PictureList} removeItem = { this.removeFromList } openReservationModal={this.openReservationModal}/>
          //     </div>;
          //     grid_array.push(x);
          //   }
          //
          // });


      let set_1 = {
        row_count: 3,
        rows: [
            {row: 3, start: 1, end: 9},
            {row: 2, start: 1, end: 9},
            {row: 1, start: 1, end: 9},
        ]
      };

      let set_2 = {
        row_count: 3,
        rows: [
          {row: 3, start: 10, end: 21},
          {row: 2, start: 10, end: 20},
          {row: 1, start: 10, end: 19},
        ]
      };

      let set_3 = {
        row_count: 12,
        rows: [
          {row: 15, start: 1, end: 10},
          {row: 14, start: 1, end: 10},
          {row: 13, start: 1, end: 10},
          {row: 12, start: 1, end: 10},
          {row: 11, start: 1, end: 10},
          {row: 10, start: 1, end: 10},
          {row: 9, start: 1, end: 10},
          {row: 8, start: 1, end: 10},
          {row: 7, start: 1, end: 10},
          {row: 6, start: 1, end: 10},
          {row: 5, start: 1, end: 10},
          {row: 4, start: 1, end: 10},
        ]
      };

      let set_4 = {
        row_count: 12,
        rows: [
          {row: 15, start: 11, end: 35},
          {row: 14, start: 11, end: 34},
          {row: 13, start: 11, end: 33},
          {row: 12, start: 11, end: 32},
          {row: 11, start: 11, end: 31},
          {row: 10, start: 11, end: 30},
          {row: 9, start: 11, end: 29},
          {row: 8, start: 11, end: 28},
          {row: 7, start: 11, end: 27},
          {row: 6, start: 11, end: 26},
          {row: 5, start: 11, end: 25},
          {row: 4, start: 11, end: 24},
        ]
      };

        return(
            <>
              {
                isOpen & selected!=null & seat!=0 ?
                  <ReservationDetailsModal value={ selected } seat={ seat } removeFromTheSeat={ this.removeFromTheSeat } closeReservationModal={ this.closeReservationModal } />
                  :
                  null
              }
                <Row>
                    <Col lg={3}>
                        <div className="Pictures">
                            {PictureList.map((picture) => {
                                return <Picture url={`${ picture.firstName }  ${ picture.lastName }`} email={ picture.email } mobile={ picture.mobile } points={ picture.points } id={ picture.userId } />;
                            })}
                        </div>
                    </Col>
                    <Col lg={9}>
                        <Row className={"seat-row"}>

                            <div className={"seats-section"}>

                              <div className={"seats-box seat-right"}>

                                <div className={"seat-line-1"}>
                                  <div className={"seat-set-2"}>
                                    {
                                      set_4.rows.map((value, idx) => {
                                        return <div className={"seat-set-row"}>
                                          <div className={"seat-set-row-name-2"}><span>{`${value.row} R`}</span></div>
                                          <div className={"seat-set-row-seats-2 seats-align-right"}>
                                            {
                                              [...Array((value.end - value.start) + 1)].map((val,idx) => {
                                                return <DragDrop key={ `R${value.row}-${value.end - idx}`} seat = { `R${value.row}-${value.end - idx}` } reserverdList = { this.state.reserved_seats } pictureList = { this.state.PictureList } makeReservation={ this.makeReservation } removeItem = { this.removeFromList } openReservationModal={this.openReservationModal}/>
                                              })
                                            }
                                          </div>
                                          <div className={"seat-set-row-name-2"}><span>{`${value.row} R`}</span></div>
                                        </div>
                                      })
                                    }
                                  </div>

                                  <div className={"seat-row-path"}></div>

                                  <div className={"seat-set-1"}>
                                    {
                                      set_2.rows.map((value, idx) => {
                                        return <div className={"seat-set-row"}>
                                          <div className={"seat-set-row-name-2"}><span>{`${value.row} R`}</span></div>
                                          <div className={"seat-set-row-seats-2 seats-align-right"}>
                                            {
                                              [...Array((value.end - value.start) + 1)].map((val,idx) => {
                                                return <DragDrop key={`R${value.row}-${value.end - idx}`} seat = { `R${value.row}-${value.end - idx}` } reserverdList = { this.state.reserved_seats } pictureList = {this.state.PictureList} makeReservation={ this.makeReservation } removeItem = { this.removeFromList } openReservationModal={this.openReservationModal}/>
                                              })
                                            }
                                          </div>
                                          <div className={"seat-set-row-name-2"}><span>{`${value.row} R`}</span></div>
                                        </div>
                                      })
                                    }
                                  </div>
                                </div>

                                <div className={"seat-line-path"}></div>

                                <div className={"seat-line-2"}>
                                  <div className={"seat-line-1"}>
                                    <div className={"seat-set-2"}>
                                      {
                                        set_3.rows.map((value, idx) => {
                                          return <div className={"seat-set-row"}>
                                            <div className={"seat-set-row-name-1"}><span>{`${value.row} R`}</span></div>
                                            <div className={"seat-set-row-seats-1 seats-align-center"}>
                                              {
                                                [...Array((value.end - value.start) + 1)].map((val,idx) => {
                                                  return <DragDrop key={ `R${value.row}-${value.end - idx}` } seat = { `R${value.row}-${value.end - idx}` } reserverdList = { this.state.reserved_seats } pictureList = {this.state.PictureList} makeReservation={ this.makeReservation } removeItem = { this.removeFromList } openReservationModal={this.openReservationModal}/>
                                                })
                                              }
                                            </div>
                                            <div className={"seat-set-row-name-1"}><span>{`${value.row} R`}</span></div>
                                          </div>
                                        })
                                      }
                                    </div>

                                    <div className={"seat-row-path"}></div>

                                    <div className={"seat-set-1"}>
                                      {
                                        set_1.rows.map((value, idx) => {
                                          return <div className={"seat-set-row"}>
                                            <div className={"seat-set-row-name-1"}><span>{`${value.row} R`}</span></div>
                                            <div className={"seat-set-row-seats-1 seats-align-center"}>
                                              {
                                                [...Array((value.end - value.start) + 1)].map((val,idx) => {
                                                  return <DragDrop key={`R${value.row}-${value.end - idx}`} seat = { `R${value.row}-${value.end - idx}` } reserverdList = { this.state.reserved_seats } pictureList = {this.state.PictureList} makeReservation={ this.makeReservation } removeItem = { this.removeFromList } openReservationModal={this.openReservationModal}/>
                                                })
                                              }
                                            </div>
                                            <div className={"seat-set-row-name-1"}><span>{`${value.row} R`}</span></div>
                                          </div>
                                        })
                                      }
                                    </div>
                                  </div>
                                </div>

                              </div>

                              <div className={"seat-main-path"}></div>

                              <div className={"seats-box seat-left"}>

                                <div className={"seat-line-2"}>
                                  <div className={"seat-line-1"}>
                                    <div className={"seat-set-2"}>
                                      {
                                        set_3.rows.map((value, idx) => {
                                          return <div className={"seat-set-row"}>
                                            <div className={"seat-set-row-name-1"}><span>{`${value.row} L`}</span></div>
                                            <div className={"seat-set-row-seats-1 seats-align-center"}>
                                              {
                                                [...Array((value.end - value.start) + 1)].map((val,idx) => {
                                                  return <DragDrop key={`L${value.row}-${value.start + idx}`} seat = { `L${value.row}-${value.start + idx}` } reserverdList = { this.state.reserved_seats } pictureList = {this.state.PictureList} makeReservation={ this.makeReservation } removeItem = { this.removeFromList } openReservationModal={this.openReservationModal}/>
                                                })
                                              }
                                            </div>
                                            <div className={"seat-set-row-name-1"}><span>{`${value.row} L`}</span></div>
                                          </div>
                                        })
                                      }
                                    </div>

                                    <div className={"seat-row-path"}></div>

                                    <div className={"seat-set-1"}>
                                      {
                                        set_1.rows.map((value, idx) => {
                                          return <div className={"seat-set-row"}>
                                            <div className={"seat-set-row-name-1"}><span>{`${value.row} L`}</span></div>
                                            <div className={"seat-set-row-seats-1 seats-align-center"}>
                                              {
                                                [...Array((value.end - value.start) + 1)].map((val,idx) => {
                                                  return <DragDrop key={`L${value.row}-${value.start + idx}`} seat = { `L${value.row}-${value.start + idx}` } reserverdList = { this.state.reserved_seats } pictureList = {this.state.PictureList} makeReservation={ this.makeReservation } removeItem = { this.removeFromList } openReservationModal={this.openReservationModal}/>
                                                })
                                              }
                                            </div>
                                            <div className={"seat-set-row-name-1"}><span>{`${value.row} L`}</span></div>
                                          </div>
                                        })
                                      }
                                    </div>
                                  </div>
                                </div>


                                <div className={"seat-line-path"}></div>

                                <div className={"seat-line-1"}>
                                  <div className={"seat-set-2"}>
                                    {
                                      set_4.rows.map((value, idx) => {
                                        return <div className={"seat-set-row"}>
                                          <div className={"seat-set-row-name-2"}><span>{`${value.row} L`}</span></div>
                                          <div className={"seat-set-row-seats-2"}>
                                            {
                                              [...Array((value.end - value.start) + 1)].map((val,idx) => {
                                                return <DragDrop key={`L${value.row}-${value.start + idx}`} seat = { `L${value.row}-${value.start + idx}` } reserverdList = { this.state.reserved_seats } pictureList = {this.state.PictureList} makeReservation={ this.makeReservation } removeItem = { this.removeFromList } openReservationModal={this.openReservationModal}/>
                                              })
                                            }
                                          </div>
                                          <div className={"seat-set-row-name-2"}><span>{`${value.row} L`}</span></div>
                                        </div>
                                      })
                                    }
                                  </div>

                                  <div className={"seat-row-path"}></div>

                                  <div className={"seat-set-1"}>
                                    {
                                      set_2.rows.map((value, idx) => {
                                        return <div className={"seat-set-row"}>
                                          <div className={"seat-set-row-name-2"}><span>{`${value.row} L`}</span></div>
                                          <div className={"seat-set-row-seats-2"}>
                                            {
                                              [...Array((value.end - value.start) + 1)].map((val,idx) => {
                                                  return <DragDrop key={`L${value.row}-${value.start + idx}`} seat = { `L${value.row}-${value.start + idx}` } reserverdList = { this.state.reserved_seats } pictureList = {this.state.PictureList} makeReservation={ this.makeReservation } removeItem = { this.removeFromList } openReservationModal={this.openReservationModal}/>
                                              })
                                            }
                                          </div>
                                          <div className={"seat-set-row-name-2"}><span>{`${value.row} L`}</span></div>
                                        </div>
                                      })
                                    }
                                  </div>
                                </div>

                              </div>

                            </div>

                        </Row>
                    </Col>
                </Row>
                {
                    this.state.loading?
                        <Spinner/>
                        :
                        null
                }
            </>
        )
    }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  current_event: state.eventReducer.current_event,
  current_sub_events: state.eventReducer.current_sub_events,
  current_sub_event_id: state.eventReducer.currentSubEventId,
  current_sub_event_idx: state.eventReducer.current_sub_event_id,
  et_r: state.eventReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    setCurrentSubEvent: (data) => dispatch(actionCreator.setCurrentSubEvent(data)),
    setCurrentSubEventsData: (data) => dispatch(actionCreator.setCurrentSubEventsData(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DropContainer));
